import { PlanningEvent } from "../models/planning-event.model";
import { CellStatus } from "../models/planning-cell.model";

export function deriveCellStatus<P = unknown>(
  events: PlanningEvent<P>[],
  cellDate: Date,
  today: Date,
): CellStatus {
  if (events.length === 0) return "empty";
  if (events.some((e) => e.status === "blocked")) return "blocked";

  const cellDay = startOfDayTs(cellDate);
  const todayDay = startOfDayTs(today);

  if (cellDay < todayDay) {
    if (events.some((e) => e.status === "pending" || e.status === "late"))
      return "late";
    if (events.some((e) => e.status === "partial")) return "partial";
    if (events.every((e) => e.status === "cancelled")) return "cancelled";
    return "completed";
  }

  if (cellDay === todayDay) {
    if (events.every((e) => e.status === "completed")) return "completed";
    if (events.every((e) => e.status === "cancelled")) return "cancelled";
    return "in_progress";
  }

  // Futur
  if (events.every((e) => e.status === "pending")) return "planned";
  if (events.every((e) => e.status === "cancelled")) return "cancelled";
  return "in_progress";
}

function startOfDayTs(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}
